import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from './auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(protected authService: AuthService, protected router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkActivation(state);
  }

  private checkActivation(state: RouterStateSnapshot) {
    const authResult = this.authService.isAuthenticated();
    return authResult ? authResult : this.router.navigate(['login'], {queryParams: {returnUrl: state.url}});
  }
}
